<template>
  <div
    :class="`tp-product-item-3 ${
      primary_style ? 'tp-product-style-primary' : ''
    } mb-50 ${isCenter ? 'text-center' : ''}`"
  >
    <div
      class="tp-product-thumb-3 mb-15 fix p-relative z-index-1"
      :style="`background-color: ${style_2 ? '#f6f6f6' : '#fff'};`"
    >
      <nuxt-link-locale :href="`/product-details/${item.slug}`">
        <img :src="item.main_img?.full_url" alt="product-img" />
      </nuxt-link-locale>

      <!-- product action -->
      <div class="tp-product-action-3 tp-product-action-blackStyle">
        <div class="tp-product-action-item-3 d-flex flex-column">
          <button
            type="button"
            class="tp-product-action-btn-3 tp-product-quick-view-btn"
            data-bs-toggle="modal"
            :data-bs-target="`#${utilityStore.modalId}`"
            @click="
              utilityStore.handleOpenModal(`product-modal-${item.id}`, item)
            "
          >
            <svg-cart-bag-2 />
            <span class="tp-product-tooltip">{{ $t("Add to Cart") }}</span>
          </button>
          <button
            @click="wishlistStore.add_wishlist_product(item)"
            type="button"
            :class="`tp-product-action-btn-3 tp-product-add-to-wishlist-btn ${
              isItemInWishlist(item) ? 'active' : ''
            }`"
          >
            <svg-wishlist />
            <span class="tp-product-tooltip">
              {{
                isItemInWishlist(item)
                  ? "Remove From Wishlist"
                  : "Add To Wishlist"
              }}
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="tp-product-content-3">
      <div class="tp-product-tag-3">
        <span>{{ item.brand_details.name }}</span>
      </div>
      <h3 class="tp-product-title-3">
        <nuxt-link-locale :href="`/product-details/${item.slug}`">{{
          item.name
        }}</nuxt-link-locale>
      </h3>
      <div class="tp-product-price-wrapper-3">
        <span v-if="item.old_price" class="tp-product-price-3">
          {{ formatPrice(item.price.toFixed(2)) }}
        </span>
        <span v-else class="tp-product-price-3">{{
          formatPrice(item.price.toFixed(2))
        }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from "@/pinia/useCartStore";
import { useWishlistStore } from "@/pinia/useWishlistStore";
import { useUtilityStore } from "@/pinia/useUtilityStore";
import { type IProduct } from "@/types/product-type";
import { useCurrencyStore } from "../../../pinia/useCurrencyStore";
// props
defineProps<{
  item: IProduct;
  style_2?: boolean;
  isCenter?: boolean;
  primary_style?: boolean;
}>();

const cartStore = useCartStore();
const wishlistStore = useWishlistStore();
const utilityStore = useUtilityStore();
const { formatPrice } = useCurrencyStore();
function isItemInWishlist(product: IProduct) {
  return wishlistStore.wishlists.some((prd) => prd.id === product.id);
}

function isItemInCart(product: IProduct) {
  return cartStore.cart_products.some((prd) => prd.id === product.id);
}
</script>
